import { useEffect, useState } from 'react'

function useCurrentWindowWidth() {
    const [currentWindowWidth, setCurrentWindowWidth] = useState({width: window.innerWidth, height: window.innerHeight});
    const handleSetWidth = () =>{
        setCurrentWindowWidth({width: window.innerWidth, height: window.innerHeight})
    }

    useEffect(()=>{
        window.addEventListener('resize', handleSetWidth);
        return ()=>{
            window.removeEventListener('resize', handleSetWidth);
        }
    }, [])

    return currentWindowWidth;
}

export default useCurrentWindowWidth;